/* Le Chic Beauty theme bridge.
   Runs the site's page renderers on Shopify: maps site paths to Shopify URLs and theme
   assets, reads page parameters from window.LC_PAGE, applies live Shopify prices and
   availability, and sends Customer Care forms through the Shopify contact form.
   Load after lc-catalog.js, lc-journal.js, lc-data.js and lc-seo.js. */
(function () {
  const ASSETS = window.LC_ASSETS || '';
  const SHOP = window.LC_SHOP_PRODUCTS || {};
  const hasShop = Object.keys(SHOP).length > 0;

  /* ---------- Images: images/... -> theme assets ---------- */
  LC.asset = (src) => {
    if (typeof src !== 'string') return src;
    let m;
    if ((m = src.match(/^(?:\.\.\/)*images\/products\/([^/]+)\/([^/?#]+)$/))) return `${ASSETS}lc-p-${m[1]}-${m[2]}`;
    if ((m = src.match(/^(?:\.\.\/)*images\/sq\/([^/?#]+)$/))) return `${ASSETS}lc-sq-${m[1]}`;
    if ((m = src.match(/^(?:\.\.\/)*images\/([^/?#]+)$/))) return `${ASSETS}lc-${m[1]}`;
    return src;
  };

  LC.products.forEach((p) => {
    p.images.forEach((i) => { i.src = LC.asset(i.src); });
    p.options.forEach((o) => { if (o.image) o.image = LC.asset(o.image); });
    p.videos.forEach((v) => {
      if (v.poster) v.poster = LC.asset(v.poster);
      if (v.src) v.src = LC.asset(v.src);
    });
  });
  Object.values(LC.collections).forEach((c) => { if (c.image) c.image = LC.asset(c.image); });
  (window.LC_JOURNAL || []).forEach((a) => {
    a.cover = LC.asset(a.cover);
    a.body = String(a.body || '').replace(/src="([^"]+)"/g, (m, s) => `src="${LC.asset(s)}"`);
  });

  const howToPoster = LC.howToPoster;
  LC.howToPoster = (p) => LC.asset(howToPoster(p));
  const collectionImage = LC.collectionImage;
  LC.collectionImage = (key) => {
    const img = collectionImage(key);
    return Object.assign({}, img, { src: LC.asset(img.src) });
  };
  LC.blueImage = (p) => {
    const img = p.images.find((i) => i.src.indexOf('lc-sq-') !== -1) || p.images[0];
    return img ? { src: img.src, alt: img.alt, lifestyle: false } : LC.productImage(p);
  };

  /* ---------- Live Shopify prices and availability ---------- */
  if (hasShop) {
    LC.products.forEach((p) => {
      const s = SHOP[p.id];
      p.inShop = Boolean(s);
      if (s) {
        p.price = s.price / 100;
        p.available = s.available;
        p.hasPlans = s.plans > 0;
        // A Shopify product that holds several lengths advertises its lowest price;
        // use the price of the length this page is about (14-16, 16-18, 18-20).
        const lengthDigits = (String(p.id).match(/(\d{2})-(\d{2})/) || []).slice(1).join('');
        if (s.lengths && lengthDigits) {
          Object.keys(s.lengths).forEach((value) => {
            if (String(value).replace(/\D/g, '') === lengthDigits) p.price = s.lengths[value] / 100;
          });
        }
      } else {
        // Not in Shopify yet: keep the catalog price for reference, but nobody can buy it
        p.inShop = false;
        p.available = false;
      }
    });
  }

  /* ---------- Every Shopify hair tool joins the Hair Tools collection ---------- */
  // Tools added in Shopify (Flat Irons, Blow Dryers, Curlers, Straightening Brushes) appear
  // automatically, with their Shopify colors and photos. Retired and warranty items stay out.
  const TOOL_COLLECTIONS = [['blow-dryers', 'blow-dryers'], ['curlers', 'curling'], ['flat-irons', 'flat-irons'], ['straightening-brushes', 'flat-irons']];
  if (hasShop) {
    Object.keys(SHOP).forEach((handle) => {
      const s = SHOP[handle];
      if (!s.title || LC.findProduct(handle) || (LC.retiredIds || []).includes(handle) || /warranty|file-a-claim/.test(handle)) return;
      const cols = String(s.cols || '').split(',');
      const match = TOOL_COLLECTIONS.find(([col]) => cols.includes(col));
      if (!match) return;
      const options = (s.options || []).filter((o) => !/^default title$/i.test(o.name));
      const images = [];
      const addImage = (src, alt) => { if (src && !images.some((i) => i.src === src)) images.push({ src, alt }); };
      addImage(s.image, s.title);
      options.forEach((o) => addImage(o.image, `${s.title} in ${o.name}`));
      LC.products.push({
        id: handle,
        name: s.title,
        category: match[1],
        price: s.price / 100,
        available: s.available,
        hasPlans: s.plans > 0,
        inShop: true,
        optionLabel: 'Color',
        options: options.map((o) => ({ name: o.name, image: o.image || null })),
        images,
        description: s.description || '',
        features: [],
        benefits: [],
        highlights: [],
        directions: [],
        ingredients: null,
        videos: []
      });
    });
  }

  /* ---------- URLs ---------- */
  const COLLECTIONS = {
    all: '/collections/all',
    tools: '/collections/all?view=tools',
    care: '/collections/hair-care',
    'hair-care': '/collections/repairing-caviar-collection',
    treatments: '/collections/all?view=treatments',
    accessories: '/collections/brushes-combs-and-accessories',
    extensions: '/collections/16-18-100-human-hair-remy-halo-hair-extensions',
    'flat-irons': '/collections/flat-irons',
    'blow-dryers': '/collections/blow-dryers',
    curling: '/collections/curlers',
    travel: '/collections/all?view=travel',
    grooming: '/collections/all?view=grooming'
  };
  const PAGES = {
    contact: 'contact',
    faq: 'f-a-q',
    'register-your-tool': 'lifetime-warranty',
    'warranty-claim': 'file-warranty',
    'privacy-policy': 'privacy-policy',
    'terms-conditions': 'terms-conditions',
    'warranty-policy': 'warranty-policy',
    'extensions-guide': 'hair-extensions',
    'about-us': 'about-us'
  };

  LC.productUrl = (id) => (!hasShop || SHOP[id] ? `/products/${id}` : `/collections/all?view=product&id=${encodeURIComponent(id)}`);
  LC.collectionUrl = (key) => COLLECTIONS[key || 'all'] || COLLECTIONS.all;
  LC.pageUrl = (handle) => `/pages/${PAGES[handle] || handle}`;
  LC.articleUrl = (slug) => `/blogs/news/${slug}`;
  LC.journalUrl = '/blogs/news';

  // Relative site links ("products/x.html", "pages/faq.html#returns") -> Shopify URLs
  LC.shopUrl = (href) => {
    if (!href || /^(?:[a-z][a-z0-9+.-]*:|\/\/|\/|#|\?)/i.test(href)) return href;
    const parts = href.match(/^([^?#]*)(.*)$/);
    const path = parts[1];
    const rest = parts[2] || '';
    let m;
    if (path === '' || path === 'index.html') return `/${rest}`;
    if ((m = path.match(/^products\/(.+)\.html$/))) return LC.productUrl(m[1]) + rest;
    if ((m = path.match(/^collections\/(.+)\.html$/))) return LC.collectionUrl(m[1]) + rest;
    if ((m = path.match(/^pages\/(.+)\.html$/))) return LC.pageUrl(m[1]) + rest;
    if (path === 'blogs/news/index.html') return LC.journalUrl + rest;
    if ((m = path.match(/^blogs\/news\/(.+)\.html$/))) return LC.articleUrl(m[1]) + rest;
    return href;
  };

  const fixNode = (el) => {
    if (el.tagName === 'A' && el.hasAttribute('href')) {
      const h = el.getAttribute('href');
      const n = LC.shopUrl(h);
      if (n !== h) el.setAttribute('href', n);
    } else if (el.tagName === 'IMG' && el.hasAttribute('src')) {
      const s = el.getAttribute('src');
      const n = LC.asset(s);
      if (n !== s) el.setAttribute('src', n);
    }
  };
  LC.fixLinks = (root) => {
    if (!root || root.nodeType !== 1) return;
    fixNode(root);
    root.querySelectorAll('a[href], img[src]').forEach(fixNode);
  };
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach(LC.fixLinks));
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Page parameters (set by each section as window.LC_PAGE) ---------- */
  const param = LC.param;
  LC.param = (name) => {
    const page = window.LC_PAGE || {};
    return page[name] != null ? String(page[name]) : param(name);
  };

  /* ---------- SEO: Liquid owns the canonical URL; renderers add titles, meta and JSON-LD ---------- */
  LC.abs = (path) => new URL(LC.asset(LC.shopUrl(String(path || ''))) || '/', location.origin).href;
  const seo = LC.seo;
  LC.seo = (o) => {
    const canonical = document.head.querySelector('link[rel="canonical"]');
    const keep = canonical && canonical.getAttribute('href');
    seo(o);
    if (canonical && keep) canonical.setAttribute('href', keep);
  };

  /* ---------- Customer Care forms -> Shopify contact form (arrives in the store inbox) ---------- */
  /* Native path: #help-form is a real Shopify contact form. lc-help.js prepares files,
     strips display/file names, posts urlencoded contact[name/email/phone/body] (Preferences hCaptcha OFF).
     No off-screen proxy form; no theme captcha UI. */
  LC.CARE_EMAIL = 'hello@lechichair.com';
  LC.MAX_FILE = 350000;   // bytes after compress, per file
  LC.MAX_TOTAL = 700000;  // total inlined payload budget

  LC.readAsDataURL = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('read failed'));
    reader.readAsDataURL(file);
  });

  LC.compressImage = (file) => new Promise((resolve) => {
    if (!file.type || !file.type.startsWith('image/') || /gif|svg/i.test(file.type)) {
      resolve(file);
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const maxDim = 1400;
      let w = img.width || 1;
      let h = img.height || 1;
      const scale = Math.min(1, maxDim / Math.max(w, h));
      w = Math.max(1, Math.round(w * scale));
      h = Math.max(1, Math.round(h * scale));
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      canvas.toBlob((blob) => {
        if (!blob) { resolve(file); return; }
        const name = String(file.name || 'upload').replace(/\.[^.]+$/, '') + '.jpg';
        resolve(new File([blob], name, { type: 'image/jpeg' }));
      }, 'image/jpeg', 0.72);
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });

  /* Prepare one file input's files into inline base64 attachments + email-follow-up list.
     Returns { attachments, emailFollowUp, used }. */
  LC.prepareFiles = async (files, fieldName, usedStart) => {
    const CARE_EMAIL = LC.CARE_EMAIL;
    const MAX_FILE = LC.MAX_FILE;
    const MAX_TOTAL = LC.MAX_TOTAL;
    const attachments = [];
    const emailFollowUp = [];
    let used = usedStart || 0;
    for (const raw of Array.from(files || [])) {
      const isVideo = (raw.type || '').startsWith('video/') || /\.(mp4|mov|webm|m4v)$/i.test(raw.name || '');
      const isPdf = (raw.type === 'application/pdf') || /\.pdf$/i.test(raw.name || '');
      const isImage = (raw.type || '').startsWith('image/');
      if (isVideo) {
        emailFollowUp.push({ field: fieldName, file: raw.name, reason: 'video — email as attachment' });
        continue;
      }
      let file = raw;
      if (isImage) file = await LC.compressImage(raw);
      if (!isImage && !isPdf) {
        emailFollowUp.push({ field: fieldName, file: raw.name, reason: 'unsupported type for inline upload' });
        continue;
      }
      if ((file.size || 0) > MAX_FILE || used + (file.size || 0) > MAX_TOTAL) {
        emailFollowUp.push({ field: fieldName, file: raw.name, reason: 'too large for form — email as attachment' });
        continue;
      }
      try {
        const dataUrl = await LC.readAsDataURL(file);
        if (dataUrl.length > MAX_FILE * 1.4 || used + (file.size || 0) > MAX_TOTAL) {
          emailFollowUp.push({ field: fieldName, file: raw.name, reason: 'too large for form — email as attachment' });
          continue;
        }
        attachments.push({ field: fieldName, fileName: file.name, mime: file.type || 'application/octet-stream', dataUrl });
        used += file.size || 0;
      } catch (err) {
        emailFollowUp.push({ field: fieldName, file: raw.name, reason: 'could not read file — email as attachment' });
      }
    }
    return { attachments, emailFollowUp, used, careEmail: CARE_EMAIL };
  };
})();
